import type { TFunction } from 'i18next';
import { HELP_CENTER_CATEGORIES, type HelpCategory } from './help-center-topics';

/** Même arborescence traduite que sur /aide et /help (clés help.categories.* / help.topics.*). */
export function translateHelpCategories(t: TFunction): HelpCategory[] {
  return HELP_CENTER_CATEGORIES.map((cat) => ({
    ...cat,
    title: t(`help.categories.${cat.id}.title`, cat.title),
    description: t(`help.categories.${cat.id}.description`, cat.description),
    topics: cat.topics.map((topic) => ({
      ...topic,
      title: t(`help.topics.${topic.id}.title`, topic.title),
      description: t(`help.topics.${topic.id}.description`, topic.description),
    })),
  }));
}
